import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './AnonymousResultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { useIsMobile } from '../../../hooks/useIsMobile';
export const AnonymousBusinessEmailResultsHeader = _ref => {
  let {
    onBackClick,
    ...props
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const title = /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.resultsHeaderTitle
  }, t('domain_search_gate.business_email_results.title'));
  const subtitle = /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    secondary: true
  }, t('domain_search_gate.business_email_results.subtitle'));
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      align: "center",
      textAlign: "center",
      width: "100%",
      direction: "vertical",
      gap: "SP2"
    }, props), title, subtitle);
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "SP3",
    marginBottom: "SP1"
  }, /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    onBackClick: onBackClick
  }, props), title), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle"
  }, subtitle));
};
//# sourceMappingURL=AnonymousBusinessEmailResultsHeader.js.map